module.exports = {
      id: "linkedin-plain-color-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-84e6ba0859b67d2a822c8ad28bb7a5bc.svg#linkedin-plain-color",
      toString: function () {
        return this.url;
      }
    }